import { Turbo } from "@hotwired/turbo-rails"

const part = (dialog, name) => dialog.querySelector(`[data-confirm-part="${name}"]`)

function ask(message, form) {
  const dialog = document.getElementById("confirm-dialog")

  if (!dialog) return Promise.resolve(window.confirm(message))

  const data = form.dataset
  const expected = data.turboConfirmType
  const input = part(dialog, "input")
  const confirm = part(dialog, "confirm")

  part(dialog, "title").textContent = data.turboConfirmTitle || "Are you sure?"
  part(dialog, "message").textContent = message
  confirm.textContent = data.turboConfirmButton || "Confirm"
  part(dialog, "typed").hidden = !expected
  part(dialog, "expected").textContent = expected || ""
  input.value = ""
  confirm.disabled = Boolean(expected)
  confirm.classList.toggle("opacity-40", Boolean(expected))

  return new Promise((resolve) => {
    const finish = (answer) => {
      cleanup()
      dialog.close()
      resolve(answer)
    }

    const onInput = () => {
      const ok = input.value.trim() === expected

      confirm.disabled = !ok
      confirm.classList.toggle("opacity-40", !ok)
    }

    const onKey = (event) => {
      if (event.key === "Enter" && !confirm.disabled) {
        event.preventDefault()
        finish(true)
      }
    }

    const onConfirm = () => finish(true)
    const onCancel = () => finish(false)
    const onDismiss = (event) => {
      event.preventDefault()
      finish(false)
    }

    const onBackdrop = (event) => {
      if (event.target === dialog) finish(false)
    }

    const cleanup = () => {
      input.removeEventListener("input", onInput)
      input.removeEventListener("keydown", onKey)
      confirm.removeEventListener("click", onConfirm)
      dialog.querySelectorAll("[data-confirm-part=cancel]").forEach((button) => button.removeEventListener("click", onCancel))
      dialog.removeEventListener("cancel", onDismiss)
      dialog.removeEventListener("click", onBackdrop)
    }

    input.addEventListener("input", onInput)
    input.addEventListener("keydown", onKey)
    confirm.addEventListener("click", onConfirm)
    dialog.querySelectorAll("[data-confirm-part=cancel]").forEach((button) => button.addEventListener("click", onCancel))
    dialog.addEventListener("cancel", onDismiss)
    dialog.addEventListener("click", onBackdrop)

    dialog.showModal()
    ;(expected ? input : part(dialog, "cancel")).focus()
  })
}

Turbo.config.forms.confirm = ask
